import { RecentlyCreatedReportRow } from '@tap/data-providers';
import { XGridTableWrap } from '@tap/mui-ui';
import { dateTimeHelper } from '@tap/utils';

/* Таблица Недавно созданные заявки
*/

type RecentlyCreatedIssuesTableProps = {
    reportData: RecentlyCreatedReportRow[],
}

export const RecentlyCreatedIssuesTable = ({ reportData }: RecentlyCreatedIssuesTableProps) => {

    return (
        <XGridTableWrap
            rows={reportData.map(row => ({ ...row, id: row.date }))}
            dataIsLoading={false}
            tableHeight={'calc(100vh - 160px)'}
            tableWidth={'90%'}
            columns={[
                {
                    field: 'date',
                    headerName: 'Дата',
                    sortable: false,
                    type: 'date',
                    flex: 1,
                    renderCell: (cellParams) => dateTimeHelper.format(cellParams.row.date, 'dd MMMM yyyy'),
                    valueGetter: value => new Date(value),
                },
                {
                    field: 'incompletedCount',
                    headerName: 'Незавершённые заявки',
                    sortable: false,
                    type: 'number',
                    flex: 1,
                },
                {
                    field: 'completedCount',
                    headerName: 'Завершённые заявки',
                    sortable: false,
                    type: 'number',
                    flex: 1,
                },
            ]}

        />
    );
}

